<template>
    <div class="text-center">
        <vx-tooltip  v-if="isStudent" :text="userName">
            <vs-avatar size="42px" v-if="user.avatar"  :src="user.avatar" class="mx-0 my-0"/>
            <div class="con-vs-avatar ml-0 mr-3 mt-0 mb-3" v-else >
                <img  style="border-radius:25px;" width="42" height="42"  src="@/assets/images/not-photo.png">
            </div>
<!--            <vs-avatar size="42px" v-else class="mx-0 my-0" :text="avatarText"/>-->
            <div class="truncate text-xs lg:text-sm">{{user.firstName}}</div>
        </vx-tooltip>

        <div v-else :style="`background: ${color}`" class="rounded px-4 py-2">
            <vx-tooltip  :text="user.full_name">
            <div class="flex items-center">
                <div>
                    <vs-avatar size="42px" v-if="user.avatar" :src="user.avatar" class="mx-0 my-0"/>
                    <vs-avatar size="42px" v-else class="mx-0 my-0" :text="avatarText"/>
                </div>
                <div class="ml-3 text-left truncate">
                    <div class="truncate">{{user.full_name}}</div>
                    <div class="text-sm font-medium" :style="`color: ${textColor}`">{{$t('my_adviser')}}</div>
                </div>
            </div>
            </vx-tooltip>
        </div>

    </div>
</template>

<script>
import {userReplaceName, avatarText} from './utils'

export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        isStudent: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: ''
        },
        textColor: {
            type: String,
            default: ''
        }
    },
    computed: {
        userName() {
            return userReplaceName(this.$i18n, this.user)
        },
        avatarText() {
            // Если нет аватара подставляем инициалы
            return avatarText(this.userName)
        }
    },
    // created() {
    //     console.log(this.user)
    // }
}
</script>
